import React from 'react';
import { AppBar, Toolbar, Typography, Button, Box, Container } from '@mui/material';
import LogoutIcon from '@mui/icons-material/Logout';
import { customerAuth } from './customerAuth';

const CustomerLayout = ({ children, onLogout }) => {
    const user = customerAuth.getUser();

    const handleLogout = () => {
        customerAuth.logout();
        onLogout();
    };

    return (
        <Box sx={{ minHeight: '100vh', backgroundColor: '#f5f5f5' }}>
            <AppBar position="static" sx={{ backgroundColor: '#0b355d' }}>
                <Toolbar>
                    <Typography variant="h6" sx={{ flexGrow: 1 }}>
                        Pacific Landscape Supply
                    </Typography>
                    {user && (
                        <Typography variant="body2" sx={{ mr: 2, opacity: 0.8 }}>
                            {user.customerName || user.email}
                        </Typography>
                    )}
                    <Button color="inherit" onClick={handleLogout} startIcon={<LogoutIcon />} size="small">
                        Logout
                    </Button>
                </Toolbar>
            </AppBar>
            <Container maxWidth="lg" sx={{ py: 3 }}>
                {children}
            </Container>
        </Box>
    );
};

export default CustomerLayout;
